<div class="box-link"><div class="row-link"><div class="text">{{text}}</div></div></div>